import { useLang } from "@/lib/LangContext";

export const LangSwitch = () => {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="lang-switch"
      className="flex items-center gap-1 border border-white/10 font-mono-x text-xs"
    >
      <button
        data-testid="lang-switch-es"
        onClick={() => setLang("es")}
        className={`px-2 py-1 transition-colors duration-200 ${
          lang === "es"
            ? "bg-white text-black"
            : "text-slate-400 hover:text-white"
        }`}
      >
        ES
      </button>
      <button
        data-testid="lang-switch-en"
        onClick={() => setLang("en")}
        className={`px-2 py-1 transition-colors duration-200 ${
          lang === "en"
            ? "bg-white text-black"
            : "text-slate-400 hover:text-white"
        }`}
      >
        EN
      </button>
    </div>
  );
};
